<template>
  <div class="common-flexbox flex-content-left-align email-validation-container">
      <span class="heading">{{$t('verification.first_time_email_confirmation_pending_message')}}</span>
      <div class="email-heading left-align">
        <img class="reg-icon mail-icon" :src="mailIcon"/>
        <span id="emailAddress">{{ primaryEmail || emailAddress }}</span>
      </div>
      <div class="content left-align">{{$t('verification.verification_link_message')}}</div>
        <button id="resendVerificationEmailBtn" :class="{'success': isMailSent}" class="common-button gutter-bottom-10" @click="resendEmail()" :disabled= "isMailSent">
          <img class="reg-icon refresh-icon" :src="refreshIcon"/>
          {{$t(`verification.${btnTitle}`)}}
        </button>
      </div>
</template>
<script setup>
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import mailIcon from '@/assets/icons/email.svg';
import refreshIcon from '@/assets/icons/refresh.svg';

// Import composables
import { useLogin } from '@/composables/useLogin';
import { useEmailValidation } from '@/composables/useEmailValidation';

// Define component name
defineOptions({
  name: 'emailValidation'
});

// Composables
const { t } = useI18n();

// Using composables
const {
  userEmailAddress: emailAddress,
  primaryEmail,
} = useLogin();

const {
  isEmailResent,
  resendVerificationMail,
} = useEmailValidation();

// Reactive data
const isMailSent = ref(false);

// Computed properties
const btnTitle = computed(() => {
  return isMailSent.value ? 'email_send' : 'resend_email';
});

const btnTheme = computed(() => {
  return isMailSent.value ? 'success' : 'default';
});

// Methods
const resendEmail = () => {
  resendVerificationMail();
};

const onVerificationMailSent = () => {
  isMailSent.value = true;
  setTimeout(() => {
    isMailSent.value = false; 
  }, 3000);
};

// Watchers
watch(isEmailResent, (newVal, oldVal) => {
  if (newVal) {
    onVerificationMailSent();
  }
});
</script>
<style lang="stylus" scoped>
@import '~@/shared/styles/common.scss';
@import '~@/shared/styles/HeroContent.scss';
@import '~@/shared/styles/formControl.scss';
.email-heading {
  font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 0px;
    color: #000000;
    margin-bottom: 20px;
}
.refresh-icon {
  height: 18px !important;
    width: 18px !important;
    vertical-align: top !important;
}
.mail-icon {
  height: 12px !important;
  width: 15px !important;
  margin-right: 10px;
}
  .email-validation-container {
    width: 70%;
    @media screen and (max-width: 1024px) {
      width: 82%;
    }
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    #resendVerificationEmailBtn{
      background: var(--primary-color);
       margin-top: 32px;
       width: 314px;
    }  
    .heading{
      margin-bottom: 30px;
      font-family: 'Lato';
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 0.0994px;
      color: #333333;
      text-align: left;
    }
    .content {
      font-family: 'Lato';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #333333;
      text-align: left;
      max-width: 500px;
    }
  }
  .gutter-bottom-10
    margin-bottom 10px 
</style>
